module.exports = __webpack_public_path__ + "static/media/bgimage.be36dfa1.jpeg";